export const imageSources = [
    'headshots/emmettHeadshot3.png',
    'icons/resume.png',
    'icons/linkedin.png',
    'icons/github.png',
    'icons/email.png',

    'backgrounds/google_back2.jpg',
    'backgrounds/bosch_back2.jpg',
    'backgrounds/garmin_back.jpg',
    'backgrounds/nest_back.jpg',
    'backgrounds/dn_back.jpg',
    'backgrounds/olsson_back.jpg',
    'backgrounds/principal_back.jpg',
    'backgrounds/unl_back.jpg',
    'backgrounds/brainrot_back.jpg',
    'backgrounds/niyou_back.jpg',
    'backgrounds/pike_back.jpg',

    'experience/work_google.webp',
    'experience/work_bosch2.png',
    'experience/work_garmin3.png',
    'experience/work_nest2.png',
    'experience/work_brainrot.png',
    'experience/work_dn3.png',
    'experience/work_olsson2.png',
    'experience/work_principal2.png',
    'experience/work_ta.png',
    'experience/work_niyou.png',
    'experience/work_pike.png',
    
    'experienceScreens/google_screen.png',
    'experienceScreens/bosch_screen.png',
    'experienceScreens/garmin_screen.png',
    'experienceScreens/nest_screen2.png',
    'experienceScreens/dn_screen2.png',
    'experienceScreens/brainrot_screen2.png',
    'experienceScreens/olsson_screen.png',
    'experienceScreens/principal_screen.png',
    'experienceScreens/ta_screen.png',
    'experienceScreens/niyou_screen.png',
    'experienceScreens/pike_screen.png',

    'projects/bd4.png',
    'projects/civicsend 2.png',
    'projects/seekr3.png',
    'projects/pickupunl 2.png',
    'projects/projex.png',
    'projects/sure 3.png',
    'projects/blokus 1.png',
    'projects/flow.png',

    'projectScreens/bd_screen.png',
    'projectScreens/cs_screen.png',
    'projectScreens/seekr_screen2.png',
    'projectScreens/punl_screen2.png',
    'projectScreens/projex_screen.png',
    'projectScreens/sure_screen2.png',
    'projectScreens/blokus_screen.png',
    'projectScreens/flow_screen.png',
];